import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout, Breadcrumb, Row, Col } from "antd";
import appActions from "../../redux/app/actions";
import TopbarUser from "./topbarUser";
import Form from '../../components/uielements/form';
import Button from '../../components/uielements/button';
import TopbarSearch from "./topbarSearch";
import TopbarTickets from "./topbarTickets";
import TopbarNotification from "./topbarNotification";
import TopbarWrapper from "./topbar.style";
import telepaseActions from '../../redux/telepase/actions'
import {Link} from 'react-router-dom';
import themes from "../../settings/themes";
import { themeConfig } from "../../settings";
import Can from '../../settings/can';
import Moment from 'react-moment';
import Client from '../Sau/utils/client';
import { withRouter } from 'react-router-dom';
import Modal from "../../components/mycomponents/modals/Modal"
import notification from "../../components/notification"
const ClientForm = Form.create()(Client);

const { Header } = Layout;
const { toggleCollapsed } = appActions;
const customizedTheme = themes[themeConfig.theme];

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: null,
      modalActiveClient: false,
      modalActiveClientExist: false,
      confirmLoadingTitular: false,
      pathname: '',
      codigoTitularExistente:"",
    }
  }

  getName(location){
    switch (location) {
      case 'dashboard':
        return 'Inicio'
      case 'sau':
        return 'Atención al cliente'
      case 'sau_search':
        return 'Busqueda avanzada'
      case 'sau_statistics':
        return 'Estadísticas'
      case 'control_panel':
        return 'Panel de control'
      case 'ticket':
        return 'Ticket'
      case 'solicitud':
        return 'Solicitud'
      case 'user':
        return 'Usuario'
      case 'passageMethodNew':
        return 'Agregar medio de paso'
      case 'passageMethod':
        return 'Medio de paso'
      case 'billing_subprocess':
        return 'Facturación'
      case 'process':
        return 'Proceso'
      case 'billing':
        return 'Facturación'
      case 'arca':
        return 'ARCA'
      case 'billable_Concepts':
        return 'Conceptos facturables'
      case 'charges':
        return 'Cobranzas'
      case 'logs':
        return 'Logs'
      case 'invoices':
        return 'Facturas'
      case 'settings':
        return 'Configuración'
      case 'charges_statistics':
        return 'Estadísticas'
      case 'serviceBIN':
        return 'Bin de Servicio'
      case 'subprocess':
        return 'SubProceso'
      case 'category':
        return 'Solicitud'
      case 'process_group':
        return 'Procesos'
      case 'faq_question':
        return 'Pregunta'
      case 'sector':
        return 'Sector'
      case 'notification':
        return 'Notificación'
      case 'toll_operator':
        return 'Asignacion peajista'
      case 'emails':
        return 'Emails'
      default:
        return location
    }
  }
  getLocations(location){
    location = location.replace(/^\/|\/$/g, '');
    var final = []
    var locations = location.split('/')
    var url = ''
    for (var i = 0; i < locations.length; i++) {
      if (i === locations.length-1) {
        url = url+'/'+locations[i]
        if (final.length > 0) {
          final[final.length-1]['url'] = url
          final[final.length-1]['active'] = true
        }
      } else {
        var name = this.getName(locations[i]);
        url = url+'/'+locations[i]
        final.push({key:locations[i], name:name, url:url, active:false})
      }
    }
    return final
  }
  componentDidMount(){
    this._mounted = true;
    if (this.props.location.pathname) {
      this.reloadLocations(this.props.history.location.pathname)
    }
  }
  componentWillUnmount(){
    this._mounted = false;
  }
  reloadLocations(path){
    if (path !== this.state.pathname) {
      var locations2 = this.getLocations(path)
      if (this._mounted) {
        this.setState({pathname:path, locations:locations2})
      }
    }
  }
  toggleClientModal = (save=false) => {
    if (save) {
      const form = this.formClient;
      const resetFields = form.resetFields
      form.validateFields((err, values) => {
          if (err) {
              return;
          }
        this.saveClient(values, resetFields);
      });
    } else {
      this.setState({modalActiveClient:!this.state.modalActiveClient});
    }
  }
  saveClient(client, resetFields){
    var body = {
      "nombre": client.nombre,
      "apellido": client.apellido,
      "numeroDocumento": client.nroDocumento,
      "tipoDocumento": {
          "codigoDocumento": client.codigoDocumento
      },
      "telefono": client.telefono,
      "email": client.email,
    }
    this.setState({confirmLoadingTitular: true});
    this.props.saveTitular(body).then((result) => {
      if (result.error) {
        this.setState({modalActiveClient:!this.state.modalActiveClient, confirmLoadingTitular: false});
      } else {
        if(result.data.codigo == "2100"){
          this.setState({
            codigoTitularExistente: result.data.mensaje,
            confirmLoadingTitular: false,
            modalActiveClientExist:true,
          }, () => this.toggleModal("modal", {}))
        } else {
          this.setState({modalActiveClient:!this.state.modalActiveClient, confirmLoadingTitular: false});
          resetFields()
          if (window && window.location && window.location.pathname) {
            notification('success', 'Bien!', 'Usuario creado con exito');
            if (window.location.pathname === '/dashboard/charges' || window.location.pathname.includes('/dashboard/invoices/')) {
              this.props.history.push('/dashboard/invoices/'+result.data.codigoTitular);
            } else {
              this.props.history.push({pathname: "/dashboard/user/"+result.data.codigoTitular, show:'settings'});
            }
          }
        }
      }
    });
  }
  saveFormRefClient = (form) => {
      this.formClient = form;
  }
  componentDidUpdate(prevProps, prevState){
    if (prevProps.location && this.props.location &&  prevProps.location.pathname && this.props.location.pathname) {
      if (prevProps.location.pathname !== this.props.location.pathname) {
        this.reloadLocations(this.props.history.location.pathname)
      }
    }
  }

  saveRef = (object, name) => {
    this[name] = object;
  }

  RenderContentClient = (props) => {
    return (
      <>
        ¿Desea ver la ficha de este cliente?
      </>
    )
  }
  handleOk = ()=>{
    this.setState({ modalActiveClient: false, modalActiveClientExist:false }, ()=>{
      this.toggleModal("modal",{})
    });
    this.props.history.push({ pathname: "/dashboard/user/" + this.state.codigoTitularExistente, show: 'settings' });
  }

  toggleModal = (name, m, obj = null) => {
    if (this[name] && this[name].toggle) {
      this[name].toggle(m, obj);
    }
  }


  render() {
    const { locations, modalActiveClient, modalActiveClientExist, confirmLoadingTitular } = this.state;
    const { toggleCollapsed, history, user } = this.props;
    const collapsed = this.props.collapsed && !this.props.openDrawer;
    const styling = {
      background: customizedTheme.backgroundColor,
      position: "fixed",
      width: "100%",
      height:"fit-content",
      display:"block"
      // height: 70
    };
    return (
      <TopbarWrapper>
        {
          modalActiveClient ?
          <ClientForm
            ref={this.saveFormRefClient}
            toggleModal={this.toggleClientModal}
            visible={modalActiveClient}
            confirmLoadingTitular = {confirmLoadingTitular}
            history={this.props.history}/>
          :
          null
        }
        <Header
          style={styling}
          className={
            collapsed ? "isomorphicTopbar collapsed" : "isomorphicTopbar"
          }
        >
          {/*
            <div className="isoLeft">
              <button
                  className={
                    collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"
                  }
                  style={{ color: customizedTheme.textColor }}
                  onClick={toggleCollapsed}
              />
              <Breadcrumb style={{marginLeft:20, color:'#fff'}}>
                {
                  locations && locations.map(item => (
                      <Breadcrumb.Item key={item.name}><Link to={item.url} style={item.active ? { fontWeight: 'bold', color: '#fff'}:{}}>{item.name}</Link></Breadcrumb.Item>
                  ))
                }
                {
                  this.state.pathname === '/dashboard' ?
                      <Breadcrumb.Item><Link to={'/dashboard'} style={{ fontWeight: 'bold' ,color:'#fff'}}>Inicio</Link></Breadcrumb.Item>
                      :
                      null
                }
              </Breadcrumb>

            </div>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <Can I="ver" a="Titular">
                <TopbarSearch user={user} history={history}/>
              </Can>
              <Can I="crear" a="Titular">
                <Button icon="user-add" style={{marginLeft:5, height:'33.5px'}} type="primary" onClick={() => this.toggleClientModal(false)}></Button>
              </Can>
            </div>
            <ul className="isoRight">
              <li className="isoDate">
                <p>{user?user.nombreCompleto+' - ':''}<b><Moment format="DD/MM/YY HH:mm:ss" interval={1000}></Moment></b></p>
              </li>

              <Can I="ver" a="Ticket">
                <li
                    onClick={() => this.setState({ selectedItem: "tickets" })}
                    className="isoNotify"
                >
                  <TopbarTickets history={history}/>
                </li>
              </Can>

              <li
                  onClick={() => this.setState({ selectedItem: "notification" })}
                  className="isoNotify"
              >
                <TopbarNotification user={user} handleClickNotification={this.props.handleClickNotification}/>
              </li>

              <li
                  onClick={() => this.setState({ selectedItem: "user" })}
                  className="isoUser"
              >
                <TopbarUser user={user} />
              </li>
            </ul>

       */}
          <Row gutter={16} style={{width: "100%"}}>
            <Col xs={6}  xl={3} style={{height:'100%', display: 'flex',   margin: '20px 0px'}}>
              <div style={{display:"flex", justifyContent:"flex-start", alignItems:"center"}} className="isoLeft">
                <button
                    className={
                      collapsed ? "triggerBtn menuCollapsed" : "triggerBtn menuOpen"
                    }
                    style={{ color: customizedTheme.textColor }}
                    onClick={toggleCollapsed}
                />
                <Breadcrumb style={{marginLeft:20, color:'#fff'}}>
                  {
                    locations && locations.map(item => (
                        <Breadcrumb.Item key={item.name}><Link to={item.url} style={item.active ? { fontWeight: 'bold', color: '#fff'}:{}}>{item.name}</Link></Breadcrumb.Item>
                    ))
                  }
                  {
                    this.state.pathname === '/dashboard' ?
                        <Breadcrumb.Item><Link to={'/dashboard'} style={{ fontWeight: 'bold' ,color:'#fff'}}>Inicio</Link></Breadcrumb.Item>
                        :
                        null
                  }
                </Breadcrumb>

              </div>
            </Col>
            <Col  xs={18}  xl={12} style={{ height:'100%', display: 'flex', overflowX:"auto"}}>
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Can I="ver" a="Titular">
                  <TopbarSearch user={user} history={history}/>
                </Can>
                <Can I="crear" a="Titular">
                  <Button icon="user-add" style={{marginLeft:5, height:'33.5px'}} type="primary" onClick={() => this.toggleClientModal(false)}></Button>
                </Can>
              </div>
            </Col>
            <Col  xs={24}  xl={9} style={{height:'100%', display: 'flex', justifyContent:"flex-end", alignItems:"center", margin: '20px 0px'}} >
              <ul style={{display:"flex", justifyContent:"flex-end", alignItems:"center"}} className="isoRight">
                <li className="isoDate">
                  <p>{user?user.nombreCompleto+' - ':''}<b><Moment format="DD/MM/YY HH:mm:ss" interval={1000}></Moment></b></p>
                </li>

                <Can I="ver" a="Ticket">
                  <li
                      onClick={() => this.setState({ selectedItem: "tickets" })}
                      className="isoNotify"
                  >
                    <TopbarTickets history={history}/>
                  </li>
                </Can>

                <li
                    onClick={() => this.setState({ selectedItem: "notification" })}
                    className="isoNotify"
                >
                  <TopbarNotification user={user} handleClickNotification={this.props.handleClickNotification}/>
                </li>

                <li
                    onClick={() => this.setState({ selectedItem: "user" })}
                    className="isoUser"
                >
                  <TopbarUser user={user} />
                </li>
              </ul>
            </Col>
          </Row>


        </Header>
        {modalActiveClientExist &&
          <Modal
            //footer={null} 
            closable={true}
            style={{ top: 20, zIndex:9999 }}
            ref={(e) => this.saveRef(e, 'modal')}
            width={'30%'}
            Content={this.RenderContentClient}
            onOk={this.handleOk}
            //onCancel={this.handleCancel}
            title={'Cliente ya existe'}
            okText={'Aceptar'}
            cancelText={'Cancelar'} />
        }
      </TopbarWrapper>
    );
  }
}

export default withRouter(connect(
  state => ({
    ...state.App,
    ...state.Telepase
  }),
  { toggleCollapsed, ...telepaseActions }
)(Topbar));
